// extracted by mini-css-extract-plugin
module.exports = {"screenReaderLabel":"src-components-ScreenReaderLabel-styles___screenReaderLabel"};